import DocControl from "./DocControl";

export default DocControl;
